import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-websocket',
  templateUrl: './websocket.component.html',
  styleUrls: ['./websocket.component.css']
})
export class WebsocketComponent implements OnInit {

  
  copyButton: boolean = true;
  copiedButton: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  jsonData =`
  wss://gs10fq7j7g.execute-api.us-east-1.amazonaws.com/optimus?
  type=customer&token='id_token'
  `


  websocketData =`
import websocket
import sys
import jwt
import json

# Set the JWT  token
jwt_token = "xxx"

# Set the WebSocket URL
websocket_url = 'wss://gs10fq7j7g.execute-api.us-east-1.amazonaws.com/optimus?type=customer&token=' + jwt_token


def on_open(ws):
    print("WebSocket connection opened.")
    ws.send(json.dumps({"message": "Hello, world!"}))

# Define the WebSocket connection handler
def on_message(ws, message):
    # Handle received messages
    print('Received message:', message)

# Define the WebSocket error handler
def on_error(ws, error):
    # Handle errors
    print('WebSocket error:', error)

# Define the WebSocket close handler
def on_close(ws, close_code, close_reason):
    # Handle connection close
    print('WebSocket connection closed')

# Create the WebSocket connection
ws = websocket.WebSocketApp(websocket_url,
  on_message=on_message,
  on_open=on_open,
  on_error=on_error,
  on_close=on_close)

# Start the WebSocket connection
ws.run_forever()


`

copyToClipBoard(url: string) {
  var txtArea = document.createElement('textarea');
  txtArea.id = 'txt';
  txtArea.style.position = 'fixed';
  txtArea.style.top = '0';
  txtArea.style.left = '0';
  txtArea.style.opacity = '0';
  txtArea.value = url;
  document.body.appendChild(txtArea);
  txtArea.select();

  try {
    var successful = document.execCommand('copy');
    if (successful) {
     this.copyButton = false;
     this.copiedButton = true;
// After a few seconds, reset the button states
    setTimeout(() => {
      this.copyButton = true;
      this.copiedButton = false;
    }, 1000);
    }
  } catch (err) {
  } finally {
    document.body.removeChild(txtArea);
  }
}

copyJsonToClipboard() {
  this.copyToClipBoard(this.jsonData);
}


}
